module.exports = __webpack_public_path__ + "static/teamSmall-0b4619857a92028980d6998d3c7c60a3.png";